import { render } from "./component-adress-mail.vue?vue&type=template&id=16165711"
import script from "./component-adress-mail.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-mail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-adress-mail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16165711"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16165711', __exports__)) {
    api.reload('16165711', __exports__)
  }
  
  module.hot.accept("./component-adress-mail.vue?vue&type=template&id=16165711", () => {
    api.rerender('16165711', render)
  })

}


export default __exports__